// stylelint-disable selector-no-vendor-prefix

uic-search-field {
    display: inline-block;
    box-sizing: border-box;
    padding: 8px;

    .uic-search-field__wrapper {
        position: relative;
    }

    .uic-search-field__input {
        display: inline-block;
        box-sizing: border-box;
        width: 100%;
        height: var(--uic-search-field-height);
        padding: 4px 44px 4px 8px;
        border: 0;
        border-radius: 0;
        background: var(--uic-color-blue6a20);
        color: var(--uic-color-blue3);
        font-size: 1rem;
        font-weight: bold;

        &::placeholder {
            color: var(--uic-color-grey3a50);
            font-weight: normal;
        }

        &::-ms-clear {
            display: none;
        }

        &:focus {
            outline: 2px solid var(--uic-color-blue2);
            outline-offset: -2px;
        }

        &:hover {
            color: var(--uic-color-blue3);
            outline: 1px solid var(--uic-color-blue2);
            outline-offset: -1px;
        }

        &:active {
            color: var(--uic-color-blue3);
            outline: 2px solid var(--uic-color-blue2);
            outline-offset: -2px;
        }

        &::-moz-selection,
        &::selection {
            background-color: var(--uic-color-blue2);
            color: var(--uic-color-white);
            padding: 2px;
        }
    }

    .uic-search-field__icon {
        display: block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: var(--uic-color-grey3);
        width: var(--uic-icon-dimensions-default);
        height: var(--uic-icon-dimensions-default);
        right: 8px;

        &--interactable {
            cursor: pointer;
        }
    }
}
